import useSWR from 'swr';

import { usePrivate } from '@/components/private/PrivateContext';
import { enqueueSnackbar } from '@/providers/SnackbarProvider';

import { useGetEnterprisesByUserIdMessages } from './messages';

export interface useGetEnterprisesByUserIdOptions {
  shouldFetch?: boolean;
}

export function useGetEnterprisesByUserId(
  userId: number | undefined,
  options?: useGetEnterprisesByUserIdOptions,
) {
  const mergedOptions: useGetEnterprisesByUserIdOptions = {
    shouldFetch: true,
    ...options,
  };

  const { enterpriseApi } = usePrivate();

  const results = useSWR(
    enterpriseApi && userId && mergedOptions.shouldFetch
      ? `/api/Enterprise/GetByUserId/${userId}`
      : null,
    () => enterpriseApi?.apiEnterpriseGetByUserIdGet(userId),
    {
      onError: (error) => {
        enqueueSnackbar(
          useGetEnterprisesByUserIdMessages[
            'useGetEnterprisesByUserId.fetch.unexpectedError'
          ],
          {
            variant: 'error',
          },
        );
        console.error(
          '[BREEDLOGIC] <useGetEnterprisesByUserId> error fetching enterprises.',
          error,
        );
      },
    },
  );

  const isLoadingOrValidating =
    results.isLoading || results.isValidating || !enterpriseApi;

  return { ...results, isLoadingOrValidating };
}
